"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { saving: false };
        GState.bind(this, ['tenant']);
        this.fhandler = new FormHandler({
            key: 'manage-domain',
            autosave: true,
            crosscheck: true
        });
        this.fhandler.bind(this, this.state.tenant.domains);
    },
    DNSLookup: function (e) {
        const custom = e.target.value;
        if (!custom)
            return;
        $.get('/lookup?hostname=' + custom).done(response => this.fhandler.error('custom', false)).fail(error => this.fhandler.error('custom', false)).always(() => this.fhandler.set('custom', custom));
    },
    checkDomain: async function (e) {
        const sub = e.target.value;
        if (sub.length < 3)
            return;
        try {
            const {error, message, exist} = await Request('/institution/domain/check?checkfor=' + sub);
            if (error)
                throw new Error('Unexpected error occured. Try again');
            this.fhandler.error('sub', exist ? 'This domain already exist' : false);
            this.fhandler.set('sub', sub);
        } catch (error) {
            this.fhandler.error('sub', error);
        }
    },
    onSave: async function () {
        if (!isEmpty(this.state.formError) && Object.values(this.state.formError).includes(true))
            return;
        if (this.state.form.sub == this.state.tenant.domains.sub)
            delete this.state.form.sub;
        if (this.state.form.custom == this.state.tenant.domains.custom)
            delete this.state.form.custom;
        if (isEmpty(this.state.form)) {
            this.fhandler.alert('Nothing to update');
            return;
        }
        this.state.saving = true;
        try {
            const {error, message, institution} = await Request('/institution/domains/change', 'PATCH', this.state.form);
            if (error)
                throw new Error(message);
            this.state.saving = false;
            this.fhandler.reset();
            this.fhandler.alert('Domains updates saved. You will be redirect in 12 seconds.');
            const redirectTo = this.state.tenant.domains.sub !== institution.domains.sub ? this.state.tenant.domains.custom !== institution.domains.custom ? institution.domains.custom : institution.domains.full : institution.domains.custom;
            this.state.tenant = institution;
            setTimeout(() => document.location = '//' + redirectTo, 12000);
        } catch (error) {
            this.state.saving = false;
            this.fhandler.alert(error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Admin/sections/Domains.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    FormAlert_template = require("../../../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("3b453f"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "form-group"
      },
    marko_attrs1 = {
        "class": "form-row d-flex align-items-center rounded border"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "form-row d-flex align-items-center rounded border"
      },
    marko_node1 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "text-right"
      },
    marko_attrs5 = {
        type: "submit",
        "class": "btn btn-secondary btn-xl"
      },
    marko_node2 = marko_createElement("div", {
        "class": "col-2 text-right pr-0"
      }, "13", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("span", {
          "class": "text-muted font-medium-5"
        }, null, null, 1)
        .t("https://"),
    marko_attrs6 = {
        "class": "col pr-25"
      },
    marko_node3 = marko_createElement("div", {
        "class": "col-4 pl-0"
      }, "17", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("span", {
          "class": "font-medium-5"
        }, null, null, 1)
        .t(".multipple.com"),
    marko_attrs7 = {
        "class": "text-warning font-small-3 py-25"
      },
    marko_node4 = marko_createElement("div", {
        "class": "col-2 text-right pr-0"
      }, "25", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("span", {
          "class": "text-muted font-medium-5"
        }, null, null, 1)
        .t("https://"),
    marko_attrs8 = {
        "class": "col pr-25"
      },
    marko_attrs9 = {
        "class": "text-warning font-small-3 py-25"
      },
    marko_attrs10 = {
        "class": "d-flex align-items-center"
      },
    marko_attrs11 = {
        "class": "py-50"
      },
    marko_attrs12 = {
        "class": "font-medium-3"
      },
    marko_node5 = marko_createElement("div", {
        "class": "p-1 theme-bg-fade rounded"
      }, "48", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-unstyled m-0"
        }, null, null, 3)
        .e("li", {
            "class": "text-primary"
          }, null, null, 1)
          .t("ns1.multipple.com")
        .e("li", {
            "class": "text-primary"
          }, null, null, 1)
          .t("ns2.multipple.com")
        .e("li", {
            "class": "text-primary"
          }, null, null, 1)
          .t("ns3.multipple.com"),
    marko_attrs13 = {
        "class": "py-50"
      },
    marko_attrs14 = {
        "class": "font-medium-3"
      },
    marko_node6 = marko_createElement("br", null, "62", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs15 = {
        "class": "p-1 theme-bg-fade rounded"
      },
    marko_node7 = marko_createElement("br", null, "67", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node8 = marko_createElement("span", {
        "class": "text-primary"
      }, "68", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("sub.yourdomain.com"),
    marko_node9 = marko_createElement("br", null, "71", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node10 = marko_createElement("span", {
        "class": "text-primary"
      }, "72", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("sea-turtle-app-ug7av.ondigitalocean.app"),
    marko_attrs16 = {
        "class": "py-50"
      },
    marko_attrs17 = {
        "class": "font-medium-3"
      },
    marko_node11 = marko_createElement("div", {
        "class": "p-1 theme-bg-fade rounded"
      }, "80", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-unstyled m-0"
        }, null, null, 3)
        .e("li", {
            "class": "text-primary"
          }, null, null, 1)
          .t("ns1.multipple.com")
        .e("li", {
            "class": "text-primary"
          }, null, null, 1)
          .t("ns2.multipple.com")
        .e("li", {
            "class": "text-primary"
          }, null, null, 1)
          .t("ns3.multipple.com");

function render(input, out, __component, component, state) {
  var data = input;

  Row_tag({
      col: [
          {
              renderBody: function(out) {
                out.be("h4", null, "2", component);

                Locale_tag({
                    text: "Manage Domains"
                  }, out, __component, "3");

                out.ee();

                out.be("p", null, "4", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Use default domain or custom domain for your platform");
                    }
                  }, out, __component, "5");

                out.ee();

                out.n(marko_node0, component);

                Row_tag({
                    col: [
                        {
                            ns: "col-8",
                            qs: "col-11",
                            hs: "col-11",
                            renderBody: function(out) {
                              out.be("form", null, "@manage-domain", component);

                              out.be("div", marko_attrs0, "9", component);

                              out.be("label", null, "10", component);

                              Locale_tag({
                                  text: "Sub-domain"
                                }, out, __component, "11");

                              out.ee();

                              out.e("div", marko_attrs1, "12", component, 3)
                                .n(marko_node2, component)
                                .e("div", marko_attrs6, "15", component, 1)
                                  .e("input", {
                                      id: "search-input",
                                      "class": "form-control form-control-xl font-medium-5 text-right border-none pr-0",
                                      name: "sub",
                                      placeholder: Locale("sub-domain"),
                                      value: state.form.sub,
                                      validate: component.fhandler.define({
                                          name: "subdomain",
                                          regexp: "/^[a-z_]+$/"
                                        })
                                    }, "16", component, 0, 0, {
                                      onchange: __component.d("change", "checkDomain", false)
                                    })
                                .n(marko_node3, component);

                              if (state.formError.sub) {
                                out.be("p", marko_attrs7, "19", component);

                                Locale_tag({
                                    text: state.formError.sub
                                  }, out, __component, "20");

                                out.ee();
                              }

                              out.ee();

                              out.be("div", marko_attrs2, "21", component);

                              out.be("label", null, "22", component);

                              Locale_tag({
                                  text: "Custom domain"
                                }, out, __component, "23");

                              out.ee();

                              out.e("div", marko_attrs3, "24", component, 2)
                                .n(marko_node4, component)
                                .e("div", marko_attrs8, "27", component, 1)
                                  .e("input", {
                                      id: "search-input",
                                      "class": "form-control form-control-xl font-medium-5 border-none",
                                      name: "custom",
                                      placeholder: Locale("yourdomain.com"),
                                      value: state.form.custom,
                                      validate: component.fhandler.define({
                                          name: "domain",
                                          regexp: "/^[w-]+(.[w-]+)$/"
                                        })
                                    }, "28", component, 0, 0, {
                                      onchange: __component.d("change", "DNSLookup", false)
                                    });

                              if (state.formError.custom) {
                                out.be("p", marko_attrs9, "29", component);

                                Locale_tag({
                                    text: (typeof state.formError.custom) == "string" ? state.formError.custom : "Invalid domain"
                                  }, out, __component, "30");

                                out.ee();
                              }

                              out.ee();

                              out.n(marko_node1, component);

                              FormAlert_tag({
                                  alert: state.alert
                                }, out, __component, "32");

                              out.be("div", marko_attrs4, "33", component);

                              out.be("button", marko_attrs5, "34", component, null, 0, {
                                  onclick: __component.d("click", "onSave", false)
                                });

                              out.t(" ");

                              Locale_tag({
                                  text: "Save Changes"
                                }, out, __component, "35");

                              Preloader_tag({
                                  active: state.saving,
                                  class: "font-medium-5 float-right"
                                }, out, __component, "36");

                              out.ee();

                              out.ee();

                              out.ee();
                            }
                          }
                      ]
                  }, out, __component, "7");
              }
            },
          {
              ns: "col-4",
              qs: "col-5",
              hs: "d-none",
              renderBody: function(out) {
                out.be("div", marko_attrs10, "38", component);

                Bx_tag({
                    bxs: true,
                    type: "help-circle",
                    class: "font-large-2 text-info"
                  }, out, __component, "39");

                Locale_tag({
                    text: "Scenario",
                    class: "px-1"
                  }, out, __component, "40");

                out.ee();

                out.be("section", marko_attrs11, "41", component);

                out.be("h5", marko_attrs12, "42", component);

                out.t("1 — ");

                Locale_tag({
                    renderBody: function(out) {
                      out.t("I have bought a new domain and I will use the primary domain for my learning platform.");
                    }
                  }, out, __component, "43");

                out.ee();

                out.be("p", null, "44", component);

                Locale_tag({
                    text: "Primary domain",
                    class: "text-primary"
                  }, out, __component, "45");

                out.t(": yourdomain.com");

                out.ee();

                out.be("p", null, "46", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Login in to your domain registrar's dashboard and change your names servers to:");
                    }
                  }, out, __component, "47");

                out.ee();

                out.n(marko_node5, component);

                out.ee();

                out.be("section", marko_attrs13, "53", component);

                out.be("h5", marko_attrs14, "54", component);

                out.t("2 — ");

                Locale_tag({
                    renderBody: function(out) {
                      out.t("I already have my website running on my primary domain (yourdomain.com) and I would like to use a subdomain for my learning platform:");
                    }
                  }, out, __component, "55");

                out.ee();

                out.be("p", null, "56", component);

                Locale_tag({
                    text: "Sub-domain",
                    class: "text-primary"
                  }, out, __component, "57");

                out.t(": sub.yourdomain.com");

                out.ee();

                out.be("p", null, "58", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Login to your hosting provider and add a CNAME to your DNS record:");
                    }
                  }, out, __component, "59");

                out.ee();

                out.be("p", null, "60", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("In your DNS Manager");
                    }
                  }, out, __component, "61");

                out.n(marko_node6, component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Select CNAME");
                    }
                  }, out, __component, "63");

                out.ee();

                out.be("div", marko_attrs15, "64", component);

                out.be("p", null, "65", component);

                Locale_tag({
                    text: "Host",
                    class: "font-small-3"
                  }, out, __component, "66");

                out.n(marko_node7, component);

                out.t(" ");

                out.n(marko_node8, component);

                out.ee();

                out.be("p", null, "69", component);

                Locale_tag({
                    text: "Qualified Domain name",
                    class: "font-small-3"
                  }, out, __component, "70");

                out.n(marko_node9, component);

                out.n(marko_node10, component);

                out.ee();

                out.ee();

                out.ee();

                out.be("section", marko_attrs16, "73", component);

                out.be("h5", marko_attrs17, "74", component);

                out.t("3 — ");

                Locale_tag({
                    renderBody: function(out) {
                      out.t("I have a existing domain and would like to use it as a primary domain for my learning platform.");
                    }
                  }, out, __component, "75");

                out.ee();

                out.be("p", null, "76", component);

                Locale_tag({
                    text: "Primary domain",
                    class: "text-primary"
                  }, out, __component, "77");

                out.t(": yourdomain.com");

                out.ee();

                out.be("p", null, "78", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Login in to your domain registrar's dashboard and change your names servers to:");
                    }
                  }, out, __component, "79");

                out.ee();

                out.n(marko_node11, component);

                out.ee();
              }
            }
        ]
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
